
const settingConfig = {
  // setting > msp > update
  "/ents/:entId.update": {
    protocol: "ws",
    resource: "/ents/:entId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org > update
  "/orgs/:orgId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > msp/org > update
  "/ents/:entId/orgs/:orgId.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org/site > update
  "/orgs/:orgId/sites/:siteId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > msp/org/site > update
  "/ents/:entId/orgs/:orgId/sites/:siteId.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org/site > delete
  "/orgs/:orgId/sites/:siteId.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId",
    restful: true,
    method: "delete",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > msp/org/site > delete
  "/ents/:entId/orgs/:orgId/sites/:siteId.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId",
    restful: true,
    method: "delete",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > msp/org > delete
  "/ents/:entId/orgs/:orgId.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId",
    restful: true,
    method: "delete",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > msp/org > leave
  "/ents/:entId/orgs/:orgId/leave.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/leave",
    restful: true,
    method: "update",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > msp > delete
  "/ents/:entId.delete": {
    protocol: "ws",
    resource: "/ents/:entId",
    restful: true,
    method: "delete",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org > delete
  "/orgs/:orgId.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId",
    restful: true,
    method: "delete",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > msp > leave
  "/ents/:entId/leave.update": {
    protocol: "ws",
    resource: "/ents/:entId/leave",
    restful: true,
    method: "update",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org > leave
  "/orgs/:orgId/leave.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/leave",
    restful: true,
    method: "update",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org > get general setting
  "/orgs/:orgId.read": {
    protocol: "ws",
    resource: "/orgs/:orgId",
    restful: true,
    method: "read",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org > get SMTP setting
  "/orgs/:orgId/settings/emailProviders/default.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/emailProviders/default",
    restful: true,
    method: "read",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org > get Connectivity setting
  "/orgs/:orgId/settings/informHost.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/informHost",
    restful: true,
    method: "read",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org > update SMTP setting
  "/orgs/:orgId/settings/emailProviders/default.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/emailProviders/default",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org > update Connectivity setting
  "/orgs/:orgId/settings/informHost.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/informHost",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org > SMTP test connect
  "/orgs/:orgId/settings/emailProviders/default/testConnection.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/emailProviders/default/testConnection",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org > SMTP test send mail
  "/orgs/:orgId/settings/emailProviders/default/sendTestEmail.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/emailProviders/default/sendTestEmail",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "",
  },
  // setting > org > get inventory setting
  "/orgs/:orgId/settings/inventoryDeviceAccount.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/inventoryDeviceAccount",
    restful: true,
    method: "read",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "addDeviceDeviceAccount",
  },
  // setting > msp/org > get inventory setting
  "/ents/:entId/orgs/:orgId/settings/inventoryDeviceAccount.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/settings/inventoryDeviceAccount",
    restful: true,
    method: "read",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "addDeviceDeviceAccount",
  },
  // setting > org > update inventory setting
  "/orgs/:orgId/settings/inventoryDeviceAccount.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/inventoryDeviceAccount",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "addDeviceDeviceAccount",
  },
  // setting > msp/org > update inventory setting
  "/ents/:entId/orgs/:orgId/settings/inventoryDeviceAccount.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/settings/inventoryDeviceAccount",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "addDeviceDeviceAccount",
  },
  // setting > org/site > get device setting
  "/orgs/:orgId/sites/:siteId/settings/deviceAccount.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/deviceAccount",
    restful: true,
    method: "read",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "addDeviceDeviceAccount",
  },
  // setting > msp/org/site > get device setting
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/deviceAccount.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/deviceAccount",
    restful: true,
    method: "read",
    // buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "addDeviceDeviceAccount",
  },
  // setting > org/site > update device setting
  "/orgs/:orgId/sites/:siteId/settings/deviceAccount.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/deviceAccount",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "addDeviceDeviceAccount",
  },
  // setting > msp/org/site > update device setting
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/deviceAccount.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/deviceAccount",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.param }),
    action: null,
    mockSelector: "addDeviceDeviceAccount",
  },
};

export default settingConfig;
